export const validateJSON = (str: any) => {
    try {
        return (JSON.parse(str) && !!str);
    } catch (e) {
        return false;
    }
}

export const passwordRules =  [
        {
            required: true,
            message: 'Password is required',
        },
        {
            min: 8,
            message: 'Minimum of 8 characters'
        },
        {
            max: 128,
            message: 'Maximum of 8 characters'
        },
        {
            pattern: /(?=.*[a-z])/,
            message: '1 Lowercase Character'
        },
        {
            pattern: /(?=.*[A-Z])/,
            message: '1 Uppercase Character'
        },
        {
            pattern: /(?=.*\d)/,
            message: '1 Numeric Character'
        },
        {
            pattern: /(?=.*?[#?!@$%^&*-])/,
            message: '1 Special Character'
        },
    ]

export const numberOnly = (value:any, prev:any, all:any) => {
                                const reg = /^[0-9]+$/
                                if (reg.test(value) || value === '') {
                                    return value
                                }
                                if(!prev){
                                    return ''
                                }
                                return prev
                            }
